export default "__VITE_ASSET__CUhj6w_p__"